module.exports = __webpack_public_path__ + "img/coupon.e13068ef.png";